import React, {FunctionComponent} from 'react';

interface IQrCode {
    src: string;
}

const QrCode: FunctionComponent<IQrCode>  = ({src}) => {
    return (
        <div className="text-right text-md-center">
            <img className="qr" src={src} alt="QR" />
        </div>
    )
};

export default QrCode;